import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock, TrendingUp, TrendingDown, RefreshCw } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

const mockHistory = [
  {
    id: "1",
    product: "Farinha de Trigo Especial",
    type: "saida",
    quantity: 15,
    unit: "kg",
    user: "Maria Silva",
    date: new Date("2024-11-20T14:30:00"),
    reason: "Produção de pães",
  },
  {
    id: "2",
    product: "Pão Francês",
    type: "entrada",
    quantity: 300,
    unit: "un",
    user: "João Santos",
    date: new Date("2024-11-20T08:15:00"),
    reason: "Produção matinal",
  },
  {
    id: "3",
    product: "Açúcar Refinado",
    type: "entrada",
    quantity: 50,
    unit: "kg",
    user: "Carlos Oliveira",
    date: new Date("2024-11-19T16:45:00"),
    reason: "Compra fornecedor",
  },
  {
    id: "4",
    product: "Bolo de Chocolate",
    type: "saida",
    quantity: 5,
    unit: "un",
    user: "Ana Costa",
    date: new Date("2024-11-19T11:20:00"),
    reason: "Venda PDV",
  },
  {
    id: "5",
    product: "Croissant",
    type: "ajuste",
    quantity: -3,
    unit: "un",
    user: "Maria Silva",
    date: new Date("2024-11-19T09:00:00"),
    reason: "Ajuste de inventário - perdas",
  },
];

export function StockHistory() {
  const getTypeIcon = (type: string) => {
    switch (type) {
      case "entrada":
        return <TrendingUp className="h-4 w-4 text-success" />;
      case "saida":
        return <TrendingDown className="h-4 w-4 text-destructive" />;
      case "ajuste":
        return <RefreshCw className="h-4 w-4 text-warning" />;
      default:
        return null;
    }
  };

  const getTypeBadge = (type: string) => {
    switch (type) {
      case "entrada":
        return <Badge variant="success">Entrada</Badge>;
      case "saida":
        return <Badge variant="outline" className="border-destructive text-destructive">Saída</Badge>;
      case "ajuste":
        return <Badge variant="warning">Ajuste</Badge>;
      default:
        return null;
    }
  };

  return (
    <Card className="shadow-soft">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5 text-primary" />
          Histórico de Movimentações
        </CardTitle>
        <CardDescription>Últimas movimentações de estoque</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {mockHistory.map((entry) => (
            <div key={entry.id} className="flex items-start gap-4 p-4 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors">
              <div className="flex-shrink-0 mt-1">
                {getTypeIcon(entry.type)}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-4 mb-2">
                  <div>
                    <p className="font-semibold text-foreground">{entry.product}</p>
                    <p className="text-sm text-muted-foreground">{entry.reason}</p>
                  </div>
                  <div className="flex-shrink-0">
                    {getTypeBadge(entry.type)}
                  </div>
                </div>
                <div className="flex items-center gap-4 text-sm text-muted-foreground">
                  <span className={`font-semibold ${entry.type === "entrada" ? "text-success" : entry.type === "saida" ? "text-destructive" : "text-warning"}`}>
                    {entry.type === "entrada" ? "+" : ""}{entry.quantity} {entry.unit}
                  </span>
                  <span>•</span>
                  <span>{entry.user}</span>
                  <span>•</span>
                  <span>{format(entry.date, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
